var map = {
	"./admin": "NXey",
	"./admin.js": "NXey",
	"./default": "84q1",
	"./default.js": "84q1",
	"./index": "moKT",
	"./index.js": "moKT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+vws";


//////////////////
// WEBPACK FOOTER
// ./src/configs ^\.\/.*$
// module id = +vws
// module chunks = 10